import { render, staticRenderFns } from "./running-workflows.vue?vue&type=template&id=d35e83c2"
import script from "./running-workflows.vue?vue&type=script&lang=js"
export * from "./running-workflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports